/* MANGO MOJITO "your size": the customer's size, remembered on this device once they set it anywhere (the size guide's
   ruler, a size pill on a product page, the Size chip on a collection). It is kept as an EU size on the standard last,
   with the foot length when it came from the ruler. Lasts fit differently (ML and VERSO run a size large; the W Collection
   has its own chart), so a size carries over between lasts by foot length, from the charts mm-head passes in. Product
   cards then say what the model offers in that size, and product and collection pages mark it (mm-product.js,
   mm-collection.js); a product page chooses it on load when the model is made in it. The words come from mm-head
   (#MmYourSizeText). Storage can be missing (private windows): everything then simply shows nothing. */
window.MmYourSize = window.MmYourSize || (() => {
  const KEY = 'mm-your-size';
  let text = {};
  try { text = JSON.parse(document.getElementById('MmYourSizeText').textContent); } catch (e) { /* no words, no notes */ }

  const get = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || 'null');
      return v && /^\d{2}$/.test(String(v.eu)) ? { eu: String(v.eu), cm: v.cm ? +v.cm : null } : null;
    } catch (e) { return null; }
  };
  const set = (eu, cm) => {
    if (!/^\d{2}$/.test(String(eu))) return;
    const old = get();
    const value = { eu: String(eu), cm: cm || (old && old.eu === String(eu) ? old.cm : null) };
    try { localStorage.setItem(KEY, JSON.stringify(value)); } catch (e) { return; }
    window.dispatchEvent(new CustomEvent('mm:your-size', { detail: value }));
  };
  const clear = () => {
    try { localStorage.removeItem(KEY); } catch (e) { /* nothing kept */ }
    window.dispatchEvent(new CustomEvent('mm:your-size', { detail: null }));
  };
  const lasts = text.lasts || {};
  const chart = (last) => Object.keys(lasts[last] || {}).map((k) => ({ eu: k, cm: +lasts[last][k] })).sort((a, b) => a.cm - b.cm);
  const cmOf = (last, eu) => { const c = lasts[last] && lasts[last][String(+eu)]; return c ? +c : null; };
  // the remembered (standard) size as it is labelled on another last. ML is the standard chart one size along, so the
  // same foot is a size smaller; on any other last (the W Collection) it is the smallest size there that takes the same
  // foot (the foot from the ruler, else the longest foot of the standard size)
  const onLast = (eu, last, cm) => {
    if (!last || last === 'standard') return String(+eu);
    if (last === 'ml') return String(+eu - 1);
    const foot = cm || cmOf('standard', eu);
    const fit = foot && chart(last).find((r) => r.cm >= foot - 0.001);
    return fit ? fit.eu : String(+eu);
  };
  // a size on another last as the remembered (standard) size: on ML one size up; on any other last the largest standard
  // size whose every foot it takes, so it is never short for that size (Pod, 22 Oct 2026: W 36 counts as 37, W 45 as 44)
  const fromLast = (eu, last) => {
    if (!last || last === 'standard') return String(+eu);
    if (last === 'ml') return String(+eu + 1);
    const foot = cmOf(last, eu);
    const std = chart('standard');
    const fit = foot && (std.filter((r) => r.cm <= foot + 0.001).pop() || std[0]);
    return fit ? fit.eu : String(+eu);
  };
  // the words arrive HTML-encoded from the language files ("isn&#39;t"); decode them for textContent
  const decode = (s) => { const t = document.createElement('textarea'); t.innerHTML = s; return t.value; };
  const say = (key, values) => {
    let s = decode(text[key] || '');
    for (const k in values) s = s.split(`__${k.toUpperCase()}__`).join(values[k]);
    return s;
  };

  // product cards (mm-product-card): "Made in your size", "In stock in your size", "Sold out in your size", "Your size"
  const markCards = (root = document) => {
    const mine = get();
    root.querySelectorAll('[data-mm-yours-card]').forEach((card) => {
      const note = card.querySelector('[data-mm-yours]');
      if (!note) return;
      let words = '';
      if (mine) {
        const eu = onLast(mine.eu, card.dataset.mmLast, mine.cm);
        const made = (card.dataset.mmMade || '').split(',');
        const kind = card.dataset.mmKind;
        if (made.includes(eu)) {
          // a pair on another last is labelled differently: say it fits the customer's size, not that it is their size
          if (kind === 'archive') words = card.dataset.mmAvailable !== 'true' ? '' : (card.dataset.mmLast || 'standard') !== 'standard' ? say('archive_ml', { eu: mine.eu }) : say('archive');
          else if (kind === 'rtw') words = (card.dataset.mmStock || '').split(',').includes(eu) ? say('in_stock') : say('sold_out');
          else words = say('made');
        }
      }
      note.textContent = words;
      note.hidden = !words;
    });
  };

  const ready = () => markCards();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  window.addEventListener('mm:your-size', () => markCards());
  // another tab changed it
  window.addEventListener('storage', (e) => { if (e.key === KEY) window.dispatchEvent(new CustomEvent('mm:your-size', { detail: get() })); });

  return { get, set, clear, onLast, fromLast, cmOf, say, markCards };
})();
